import React from 'react';
import './PoseSourceTabs.css';

export function PoseSourceTabs({ sourceMode, onSelectMode }) {
  return (
    <div className="pose-source-tabs">
      <button
        type="button"
        className={`pose-source-tab ${sourceMode === 'camera' ? 'pose-source-tab--active' : ''}`}
        onClick={() => onSelectMode('camera')}
      >
        <span>실시간 웹캠 촬영</span>
      </button>

      <button
        type="button"
        className={`pose-source-tab ${sourceMode === 'file' ? 'pose-source-tab--active' : ''}`}
        onClick={() => onSelectMode('file')}
      >
        <span>저장된 동영상 파일 분석</span>
      </button>
    </div>
  );
}
